const defconf = Object.assign(import.meta.env, window.__RUNTIME__)
export default defconf
